import { request } from "./request.js";




export function Login(data = {}) {
    return request({
        url: "/wxuser/signin",
        method: "post",
        data,
    });
}

export function GetTypes(data = {}) {
    return request({
        url: "/wxuser/types",
        method: "post",
        data,
    });
}